import { render, staticRenderFns } from "./printHistoriaVejez.vue?vue&type=template&id=3e21437e&scoped=true"
import script from "./printHistoriaVejez.vue?vue&type=script&lang=js"
export * from "./printHistoriaVejez.vue?vue&type=script&lang=js"
import style0 from "./printHistoriaVejez.vue?vue&type=style&index=0&id=3e21437e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e21437e",
  null
  
)

export default component.exports